import { LSFetch } from '../helpers'

export const getAllNews = () => {
    return LSFetch.get(`/news/get/all/news/`)
}